"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSupportedLinkAppConfigs = exports.buildLinkAppConfigs = exports.LinkAppId = void 0;
var LinkAppId;
(function (LinkAppId) {
    LinkAppId["GOOGLE_DOC"] = "GOOGLE_DOC";
    LinkAppId["GOOGLE_SPREADSHEET"] = "GOOGLE_SPREADSHEET";
    LinkAppId["GOOGLE_PRESENTATION"] = "GOOGLE_PRESENTATION";
    LinkAppId["GOOGLE_FORM"] = "GOOGLE_FORM";
    LinkAppId["GOOGLE_DRIVE"] = "GOOGLE_DRIVE";
    LinkAppId["FIGMA_PROJECT"] = "FIGMA_PROJECT";
    LinkAppId["MICROSOFT"] = "MICROSOFT";
    LinkAppId["MIRO"] = "MIRO";
    LinkAppId["LOOM"] = "LOOM";
    LinkAppId["GITHUB"] = "GITHUB";
    LinkAppId["TYPEFORM"] = "TYPEFORM";
    LinkAppId["WINSLOW"] = "WINSLOW";
    LinkAppId["WIX"] = "WIX";
    LinkAppId["CODA"] = "CODA";
    LinkAppId["NOTION"] = "NOTION";
    LinkAppId["DROPBOX"] = "DROPBOX";
    LinkAppId["SLACK"] = "SLACK";
    LinkAppId["OTHER"] = "OTHER";
    LinkAppId["FILE"] = "FILE";
    LinkAppId["LINK_PDF"] = "LINK_PDF";
    LinkAppId["CONFLUENCE"] = "CONFLUENCE";
    LinkAppId["POLICY_PROJECT"] = "POLICY_PROJECT";
})(LinkAppId || (exports.LinkAppId = LinkAppId = {}));
//loadEnvConfig("AWS_S3_BUCKET_NAME")
const buildLinkAppConfigs = (awsS3BucketName) => {
    const googleDocConfig = {
        id: LinkAppId.GOOGLE_DOC,
        displayName: "Google Doc",
        logo: "google-docs",
        matchKeys: ["https://docs.google.com/document"],
        matchExternals: ["\\/document\\/d\\/([^/]+)"],
    };
    const googleSheetConfig = {
        id: LinkAppId.GOOGLE_SPREADSHEET,
        displayName: "Google Sheet",
        logo: "google-sheets",
        matchKeys: ["https://docs.google.com/spreadsheets"],
        matchExternals: ["\\/spreadsheets\\/d\\/([^/]+)"],
    };
    const googleSlideConfig = {
        id: LinkAppId.GOOGLE_PRESENTATION,
        displayName: "Google Slide",
        logo: "google-slides",
        matchKeys: ["https://docs.google.com/presentation"],
        matchExternals: ["\\/presentation\\/d\\/([^/]+)"],
    };
    const googleFormsConfig = {
        id: LinkAppId.GOOGLE_FORM,
        displayName: "Google Form",
        logo: "google-forms",
        matchKeys: ["https://docs.google.com/forms/"],
        matchExternals: ["\\/forms\\/d\\/([^/]+)"],
    };
    const googleDriveConfig = {
        id: LinkAppId.GOOGLE_DRIVE,
        displayName: "Google Drive",
        logo: "google-drive",
        matchKeys: ["https://drive.google.com/file"],
        matchExternals: ["\\/file\\/d\\/([^/]+)"],
    };
    const figmaConfig = {
        id: LinkAppId.FIGMA_PROJECT,
        displayName: "Figma",
        logo: "figma",
        matchKeys: ["https://www.figma.com/"],
        matchExternals: ["/file/([^/]+)", "node-id=([^&]+)"],
    };
    const miroConfig = {
        id: LinkAppId.MIRO,
        displayName: "Miro",
        logo: "miro",
        matchKeys: ["https://miro.com/app"],
        matchExternals: ["\\/app\\/board\\/([^/]+)"],
    };
    const loomConfig = {
        id: LinkAppId.LOOM,
        displayName: "Loom",
        logo: "loom",
        matchKeys: ["https://www.loom.com/share/"],
        matchExternals: ["\\/share\\/([^/]+)"],
    };
    const githubConfig = {
        id: LinkAppId.GITHUB,
        displayName: "Github",
        logo: "github",
        matchKeys: ["https://github.com/"],
        matchExternals: [],
    };
    const typeformConfig = {
        id: LinkAppId.TYPEFORM,
        displayName: "Typeform",
        logo: "typeform",
        matchKeys: ["typeform.com/|https://"],
        matchExternals: ["\\/form\\/([^/]+)"],
    };
    const winslowConfig = {
        id: LinkAppId.WINSLOW,
        displayName: "Winslow",
        logo: "winslow",
        matchKeys: [
            "https://app.usewinslow.com/",
            "https://staging.usewinslow.com/",
            "localhost:3000",
        ],
        matchExternals: [
            "\\/recording\\/([^/]+)",
            "\\/tags\\/([^/]+)",
            "\\/shares\\/([^/]+)",
        ],
    };
    const wixConfig = {
        id: LinkAppId.WIX,
        displayName: "Wix",
        logo: "wix",
        matchKeys: ["wixstudio.io/|https://"],
        matchExternals: [],
    };
    const dropboxConfig = {
        id: LinkAppId.DROPBOX,
        displayName: "Dropbox",
        logo: "dropbox",
        matchKeys: ["dropbox.com/|https://"],
        matchExternals: ["\\/scl\\/fi\\/([^/]+)"],
    };
    const slackConfig = {
        id: LinkAppId.SLACK,
        displayName: "Slack",
        logo: "slack",
        matchKeys: ["slack.com/|https://"],
        matchExternals: ["\\/archives\\/([^/]+)"],
    };
    const codaConfig = {
        id: LinkAppId.CODA,
        displayName: "Coda",
        logo: "coda",
        matchKeys: ["coda.io/|https://"],
        matchExternals: ["\\/workspaces\\/([^/]+)"],
    };
    const notionConfig = {
        id: LinkAppId.NOTION,
        displayName: "Notion",
        logo: "notion",
        matchKeys: ["notion.so/|https://", "notion.site/|https://"],
        matchExternals: [
            "(?:https?:\\/\\/)?(?:www\\.)?notion\\.so\\/([^\\/\\?]+)",
            "(?:https?:\\/\\/)?(?:www\\.)?notion\\.site\\/([^\\/\\?]+)",
        ],
    };
    const microsoftConfig = {
        id: LinkAppId.MICROSOFT,
        displayName: "Microsoft",
        logo: "microsoft",
        matchKeys: ["sharepoint.com/|https://"],
        matchExternals: [
            "/personal/[^/]+/([^?]+)|/sites/[^/]+/Shared%20Documents/([^?]+)|/sites/[^/]+/Documents/([^?]+)",
        ],
    };
    const otherConfig = {
        id: LinkAppId.OTHER,
        displayName: "Other",
        logo: "other",
        matchKeys: [
            "thisisarandomstringthatwillneverbematchedtoanythingeveryipromise",
        ],
        matchExternals: ["https?://(?:[-\\w.]|(?:%[\\da-fA-F]{2}))+/?"],
    };
    const fileConfig = {
        id: LinkAppId.FILE,
        displayName: "File",
        logo: "file",
        matchKeys: [`https://${awsS3BucketName}.s3.amazonaws.com`],
        matchExternals: ["/([^/]+)\\.[^/.]+$"],
    };
    const linkPdfConfig = {
        id: LinkAppId.LINK_PDF,
        displayName: "Link PDF",
        logo: "pdf",
        matchKeys: [".pdf"],
        matchExternals: [],
    };
    const confluenceConfig = {
        id: LinkAppId.CONFLUENCE,
        displayName: "Confluence",
        logo: "confluence",
        matchKeys: [".atlassian.net/|https://"],
        matchExternals: [],
    };
    const policyProjectConfig = {
        id: LinkAppId.POLICY_PROJECT,
        displayName: "Policy Project",
        logo: "policy-project",
        matchKeys: ["internal:policy-project/"],
        matchExternals: [],
    };
    return {
        googleDocConfig,
        googleSheetConfig,
        googleSlideConfig,
        googleFormsConfig,
        googleDriveConfig,
        figmaConfig,
        miroConfig,
        loomConfig,
        githubConfig,
        typeformConfig,
        winslowConfig,
        wixConfig,
        dropboxConfig,
        slackConfig,
        codaConfig,
        notionConfig,
        microsoftConfig,
        otherConfig,
        fileConfig,
        linkPdfConfig,
        confluenceConfig,
        policyProjectConfig,
    };
};
exports.buildLinkAppConfigs = buildLinkAppConfigs;
const getSupportedLinkAppConfigs = (awsBucketName) => {
    const configs = (0, exports.buildLinkAppConfigs)(awsBucketName);
    return Object.values(configs);
};
exports.getSupportedLinkAppConfigs = getSupportedLinkAppConfigs;
